import { cn } from "@/lib/utils"
import {
  LIFECYCLE_TAB_LABELS,
  LIFECYCLE_TAB_ORDER,
  type BidLifecycle,
  type LifecycleCounts,
} from "@/lib/bid-lifecycle"

interface BidsLifecycleTabsProps {
  active: BidLifecycle
  /** Null hides the counts (a backend before the stage model sends none). */
  counts: LifecycleCounts | null
  onChange: (lifecycle: BidLifecycle) => void
}

/**
 * The Bids list tabs (R4 plan §2.4): Active · Leads · Submitted · Closed.
 * Underline tabs, the design system's primary-tab pattern.
 */
export function BidsLifecycleTabs({ active, counts, onChange }: BidsLifecycleTabsProps) {
  return (
    <div role="tablist" aria-label="Bids by lifecycle" className="flex h-11 items-end gap-4 border-b border-border px-6">
      {LIFECYCLE_TAB_ORDER.map((lifecycle) => {
        const isActive = lifecycle === active
        return (
          <button
            key={lifecycle}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(lifecycle)}
            className={cn(
              "-mb-px inline-flex items-center gap-1.5 whitespace-nowrap border-b-2 px-2 py-2.5 text-sm transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              isActive
                ? "border-foreground font-medium text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground"
            )}
          >
            {LIFECYCLE_TAB_LABELS[lifecycle]}
            {counts && (
              <span className="text-meta tabular-nums" data-testid={`bids-tab-count-${lifecycle}`}>
                {counts[lifecycle]}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
